export enum ROUTES {
    MAIN = '/',
    PROGRAM_PAGE = 'courses/:id',
    MEMBER_PAGE = 'employee/:id',
    DRAFT_PAGE = 'static_page/pages/:name',
}
